<template>
  <div class="container">
    <div class="row">
      <div class="col-12">
        <div class="row">
          <div class="col-10">
            <h1 class="page-header">Bekräfta överenskommelse (steg 2 av 3)</h1>
            <p class="intro">Klicka i “Jag bekräftar” och gå vidare till nästa steg. Överenskommelsen sparas inte förrän
              du undertecknar i steg 3. </p>
          </div>
        </div>
        <form class="reg-form" @submit.prevent="onSubmit">
          <div class="reg-form__wrapper">
            <PDFView v-if="state.agreementPath" :path="state.agreementPath" />
          </div>
          <div class="checkbox-container">
            <div class="form-check">
              <input id="confirm" v-model="form.confirm" class="form-check-input sr-only" required
                     type="checkbox" />
              <label class="form-check-label" for="confirm">Jag bekräftar</label>
            </div>
          </div>
          <CtaPanel>
            <div class="buttons-container push-buttons-right">
              <PreviousNavLink :go-to-link="`/organisation/${orgId}`"
                               previous-label="Avbryt"></PreviousNavLink>
              <button class="btn btn-light" type="submit">Nästa steg &nbsp;&nbsp;<span
                class="fas fa-chevron-right"></span></button>
            </div>
          </CtaPanel>
        </form>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, reactive, ref } from "@vue/runtime-core";
import CtaPanel from "../components/CtaPanel.vue";
import PDFView from "../components/PDFView.vue";
import { useOrganisationStore } from "@/stores/organisation";
import { storeToRefs } from "pinia";
import { useRoute, useRouter } from "vue-router";
import PreviousNavLink from "@/components/PreviousNavLink.vue";

interface confirm {
  confirm: boolean;
}

export default defineComponent({
  name: "OrgAgreementConfirmAgreement",
  components: {
    CtaPanel,
    PDFView,
    PreviousNavLink
  },
  setup() {
    const baseUrl = import.meta.env.VITE_APP_URL;
    const organisationStore = useOrganisationStore();
    const { pubAgreement } = storeToRefs(organisationStore);
    const route = useRoute();
    const router = useRouter();
    const { orgId } = route.params;


    if (!pubAgreement?.value?.id) {
      const agreement = JSON.parse(sessionStorage.getItem("agreement") as string);
      organisationStore.setPubAgreement(agreement);
    }

    const state = reactive({
      agreementPath: `${baseUrl}/agreement/${pubAgreement?.value?.id}/GetAgreementPdf/`
    });

    const form = ref<confirm>({
      confirm: false
    });

    const onSubmit = async () => {
      if (form.value.confirm === true) {
        router.push(`/organisation/${orgId}/avtal/bekrafta/2`);
      }
    };
    return {
      state,
      orgId,
      form,
      onSubmit
    };
  }
});
</script>

<style lang="scss" scoped>
.reg-form__wrapper {
  [class^="col-"] {
    background: var(--spsm-gray-5);
    padding: 1rem;
    border-radius: 0.2rem;
  }
}

.checkbox-container {
  display: flex;
  margin-bottom: 16px;
  justify-content: end;
}
</style>